const sortButton = $('.sorting-button')

const getSortingParams = () => {
    return JSON.parse(sortButton.val())
}

export { getSortingParams }
